<template>
    <div class="home">
        <div class="main">
            <h1>{{languageStrings['Suchen Sie den Weg?']}}</h1>
            <p class="subheadline">{{languageStrings['Starten Sie hier die Navigation zu über 300 Shops']}}</p>

            <div class="main-links">
                <router-link to="/ShopFinder">
                    <img src="@/assets/shopbuttonicon.svg">
                    shop-{{languageStrings['übersicht']}}</router-link>
                <router-link :to="{name: 'Search'}"><img src="@/assets/searchicon.svg"> shop-{{languageStrings['suche']}}</router-link>
            </div>

            <ServicePoints :languageStrings="languageStrings"></ServicePoints>
        </div>


    </div>
</template>

<script>
// @ is an alias to /src

import Advertising from "../../components/Advertising";

import ServicePoints from '@/components/ServicePoints.vue'

export default {
    name: 'Home',
    components: {
        Advertising,
        ServicePoints
    },
    props: ['languageStrings', 'store']
}
</script>

<style lang="scss">
@import "../../styles/variables";

.home {
    padding-left: $advertisingPadding;
    @include portrait(){
        padding-left: 0;
        /*transform: scale(1.4);*/
        /*transform-origin: top left;*/
    }

    .servicePoints {
        position: absolute;
        bottom: 170px;

        @include portrait(){
            left: 490px;
            width: 270px;
            bottom: 65px;

            .points {
                flex-wrap: wrap;
            }
        }

    }

}

.subheadline {
    margin: 0;
    padding: 0;
    margin-bottom: 80px;
    font-size: 26px;

    @include portrait(){
        margin-bottom: 30px;
    }
}

.main-img {
    position: absolute;
    bottom: 120px;
    right: 0;
    z-index: -1;
}

.main-links {
    a {
        height: 70px;
        width: 352px;
        border: 2px solid $orange;
        display: flex;
        margin-bottom: 20px;
        border-radius: 25px;
        align-items: center;
        color: $orange;
        padding-left: 40px;
        background: white;
        font-weight: 700;
        text-transform: uppercase;

        @include buttonActive;

        img {
            margin-right: 20px;
        }
    }

    @include portrait(){
        display: flex;
        a:first-child {
            margin-right: 20px;
        }
    }

}

</style>


